import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
export function AppRouter() {
  useEffect(() => {
    document.title = 'VAXTECH GROUP SAS';
  }, []);
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<App data-id="element-13" />} data-id="element-12" />
      </Routes>
    </BrowserRouter>;
}